// extracted by mini-css-extract-plugin
export default {"Emoji":"Emoji3M-8XE7e2_T_"};